<div class="sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div
    *ngIf="!is_amount_read_running"
    class="sp-padding__x2">
    <h2 class="sp-text__center sp-color__accent">{{ 'ORDERS.AMOUNT_COLUMN_LABEL' | translate }}</h2>
    <h1 class="sp-text__center sp-color__primary">
      {{ order_amount / 100 || 0 | number : '0.2-2' }} {{ order_currency }}
    </h1>
  </div>

  <div
    *ngIf="is_amount_read_running"
    class="sp-column__center sp-width__full sp-padding__x2">
    <mat-spinner
      color="accent"
      diameter="40"></mat-spinner>
    <p class="sp-color__accent sp-text__center sp-margin__top">Loading...</p>
  </div>
</div>
